import BannerCustom from './BannerCustom';

export default BannerCustom;
